import { extractStringValueSet } from './extract-properties';

export default class ExternalAssay {

    static readonly UCI_ARCHER_VARIANTPLEX_COREMYELOID: string = 'uci.archer.variantplex.core-myeloid';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
